module.exports = __webpack_public_path__ + "img/JopieGerritsen_hekwerk_600x600px.7328f9aa.png";